<template>
  <global-dialog-card v-model="dialog" :max-width="700" title="">
    <template #title-actions>
      <img
        class="card-img-top"
        width="18%"
        :src="'https://app.restorani.bitlab.host/gallery/ordera-beli.png'"
        alt="Logo"
      />
    </template>

    <v-form v-model="valid">
      <v-row style="margin: 0 !important">
        <div class="text-center" style="width: 100%">
          <span
            style="
              font-size: 12px !important;
              text-align: center !important;
              display: block;
            "
            class="headline"
          >
            {{ $t("register_message_cost") }}
          </span>
          <span
            class="headline"
            style="font-size: 19px !important; display: block; margin-top: -9px"
          >
            {{ $t("register_message_quick") }}
          </span>
        </div>
        <v-col cols="6" style="position: relative">
          <text-field
            v-model="user.name"
            :label="$t('first_name')"
            :rules="[rules.required]"
            required
          />
          <p
            class="error white--text"
            style="
              position: absolute;
              top: 37px;
              right: 20px;
              font-size: 10px;
              padding: 2px 6px;
              border-radius: 22px;
            "
            v-if="errors.name"
          >
            X
          </p>
        </v-col>
        <v-col cols="6" style="position: relative">
          <text-field 
            v-model="user.lastname" 
            :label="$t('last_name')" 
            :rules="[rules.required]"
            required 
          />
          <p
            class="error white--text"
            style="
              position: absolute;
              top: 37px;
              right: 20px;
              font-size: 10px;
              padding: 2px 6px;
              border-radius: 22px;
            "
            v-if="errors.lastname"
          >
            X
          </p>
        </v-col>
      </v-row>
      <v-row style="margin: 0 !important">
        <v-col cols="6" style="position: relative">
          <text-field 
            v-model="user.email" 
            :label="$t('email')" 
            :rules="[rules.required, rules.email]"
            required 
          />
          <p
            class="error white--text"
            style="
              position: absolute;
              top: 37px;
              right: 20px;
              font-size: 10px;
              padding: 2px 6px;
              border-radius: 22px;
            "
            v-if="errors.email"
          >
            X
          </p>
          <p
            class="error--text"
            style="
              position: absolute;
              top: 37px;
              right: 40px;
              font-size: 10px;
              padding: 2px 6px;
            "
            v-if="errors.email"
          >
            Email већ постоји
          </p>
        </v-col>
        <v-col cols="6" style="position: relative">
          <text-field
            v-model="user.password"
            :label="$t('password')"
            :rules="[rules.required]"
            type="password"
            required
          />
          <p
            class="error white--text"
            style="
              position: absolute;
              top: 37px;
              right: 20px;
              font-size: 10px;
              padding: 2px 6px;
              border-radius: 22px;
            "
            v-if="errors.password"
          >
            X
          </p>
        </v-col>
      </v-row>
      <v-row style="margin: 0 !important">
        <v-col cols="6" style="position: relative">
          <text-field 
            v-model="user.phone" 
            type="number" 
            :label="$t('phone')" 
            :rules="[rules.required]"
            required
          />
          <p
            class="error white--text"
            style="
              position: absolute;
              top: 37px;
              right: 20px;
              font-size: 10px;
              padding: 2px 6px;
              border-radius: 22px;
            "
            v-if="errors.phone"
          >
            X
          </p>
        </v-col>
        <v-col cols="6">
          <text-field v-model="user.address" :label="$t('address')" />
        </v-col>
      </v-row>
    </v-form>

    <template #actions>
      <v-btn text @click="close">
        {{ $t("cancel") }}
      </v-btn>
      <primary-button 
        color="success" 
        dark 
        @click="register"
        :disabled="!valid || isRegistering"
        :loading="isRegistering"
      >
        {{ $t("register") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import userService from "@/services/user";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "RegisterDialog",
  mixins: [hasValidation, hasSnackbar],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: {
        name: "",
        lastname: "",
        email: "",
        phone: "",
        drzava: "",
        grad: "",
        password: "",
        address: "",
        lat: "",
        long: "",
        type: "6",
      },
      errors: {
        name: false,
        lastname: false,
        email: false,
        password: false,
        phone: false,
      },
      isRegistering: false,
      awaitingSearch: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
    "user.email": function (val) {
      if (!this.awaitingSearch) {
        this.errors.email = false;
        setTimeout(() => {
          if (this.user.email) {
            userService.checkEmail(this.user.email).then(({ data }) => {
              if (data) {
                this.errors.email = true;
              }
            });
          }
          this.awaitingSearch = false;
        }, 3500); // 2.5 sec delay
      }
      this.awaitingSearch = true;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
    resetForm() {
      this.user = {
        name: "",
        lastname: "",
        email: "",
        phone: "",
        drzava: "",
        grad: "",
        password: "",
        address: "",
        lat: "",
        long: "",
        type: "6",
      };
      this.errors = {
        name: false,
        lastname: false,
        email: false,
        password: false,
        phone: false,
      };
    },
    validateForm() {
      let isValid = true;
      
      if (!this.user.name) {
        this.errors.name = true;
        isValid = false;
      } else {
        this.errors.name = false;
      }
      
      if (!this.user.lastname) {
        this.errors.lastname = true;
        isValid = false;
      } else {
        this.errors.lastname = false;
      }
      
      if (!this.user.email) {
        this.errors.email = true;
        isValid = false;
      } else {
        this.errors.email = false;
      }
      
      if (!this.user.password) {
        this.errors.password = true;
        isValid = false;
      } else {
        this.errors.password = false;
      }
      
      if (!this.user.phone) {
        this.errors.phone = true;
        isValid = false;
      } else {
        this.errors.phone = false;
      }
      
      return isValid;
    },
    async register() {
      if (this.isRegistering) return;

      if (!this.validateForm()) {
        return;
      }

      this.isRegistering = true;

      try {
        const { data } = await userService.addNewUser(this.user);
        
        if (data.data && data.status === "success") {
          this.$emit("user-registered", {
            user: data,
            userData: this.user,
            isGuest: data.data.type === "guest"
          });
          this.resetForm();
          this.close();
        }
      } catch (error) {
        if (error.response?.data?.status === "failed") {
          this.showErrorSnackbar(error.response.data.message);
        } else {
          this.showErrorSnackbar(this.$t("registration_failed"));
        }
      } finally {
        this.isRegistering = false;
      }
    },
  },
};
</script>